var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLogsSentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Active_State",
    "data-name": "Active State",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#14a9ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLogsSentIcon);
export default __webpack_public_path__ + "static/media/message-logs-sent-icon.997608b24cf98877218f903a41ee0527.svg";
export { ForwardRef as ReactComponent };